import Icon from '../../components/Icon.vue'

Icon.register({
  'brands/amilia': {
    width: 448,
    height: 512,
    paths: [
      {
        d: 'M240.1 32c134.1 0 191.9 55.7 192 136v296.6c0 3-1 8.1-5.1 9.1-4 1-57.3 0.7-66.5 0.7s-56.8-1-59.9-2c-4-0.9-6.1-6.1-6.1-9.1v-25.4c-39.6 21.4-105.5 42.1-153.3 42.1-109.7 0-124.9-85.7-124.9-104s-5.1-95.5 30.4-111.8c31.5-13.2 156.3-36.5 243.7-47.8v-38.5c0-44.7-1-73.1-58.9-73.1-55.8 0-119.8 25.4-152.3 47.7-6.1 4.1-16.2 4.1-20.3-6.1-5.1-12.2-9.1-34.5-10.2-39.6-1.9-10.2 2.1-16.3 7.2-19.4 52.7-38.5 122.3-55.4 184.2-55.4zM290.3 380v-106.7c-44.7 4.1-95.5 20.3-119.8 33.5-21.3 10.2-18.3 40.7-18.3 52.9 0.1 11.2 6.2 44.7 59 44.7 30.4 0 57.7-11.2 79.1-24.4z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/brands/amilia.js
// module id = 705
// module chunks = 0